var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-clickable-lot-no"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.displayName)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }